//var text = ``;

////console.log(text);
var draft = {
    header: 'header',
    intro: 'intro',
    services: [
        'Hukum Perdata dan Pidana;',
        'Hukum Perusahaan; ',
        'Hukum Kepailitan; ',
        'Hukum Pasar Modal; ',
        'Hukum Hak Kekayaan Intelektual (HKI)',
        'Hukum Perburuhan;',
        'Hukum Kesehatan; ',
        'Hukum Pertambangan;',
        'Hukum Keluarga-Perkawinan; ',
        'Hukum Properti; dan',
        'Hukum Perbankan.'
    ],
    intro2: 'intro2',
    h1: 'h1',
    p1: 'p1',
    ol1: 'scope',
    h2: 'h2',
    p2: 'p2',
    h3: 'h3',
    p3: 'p3',
    ul3: ['ul31', 'ul32', 'ul33', 'ul34'],
    h4: 'h4',
    p4: 'p4',
    h5: 'h5',
    p5: 'p5'
};
var sign = 'sign';
import {
    headerImage
} from './headerImage.js';
export const docContent = [{
        image: headerImage,
        width: 529
    },
    {
        text: 'This is the title of the document',
        style: 'title'
    },
    {
        text: 'This is the subtitle of the document',
        style: 'subtitle'
    },
    {
        style: 'paragraph',
        text: draft.intro
    }, {
        style: 'paragraph',
        ul: draft.services
    }, {
        style: 'paragraph',
        text: draft.intro2
    }, {
        alignment: 'justify',
        text: draft.h1,
        style: 'header'
    }, {
        style: 'paragraph',
        text: draft.p1
    }, {
        style: 'paragraph',
        text: draft.ol1
    }, {
        alignment: 'justify',
        text: draft.h2,
        style: 'header'
    }, {
        style: 'paragraph',
        text: draft.p2
    }, {
        alignment: 'justify',
        text: draft.h3,
        style: 'header'
    }, {
        style: 'paragraph',
        text: draft.p3
    }, {
        ul: draft.ul3,
        style: 'ul'
    }, {
        text: draft.h4,
        style: 'header'
    }, {
        style: 'paragraph',
        text: draft.p4
    }, {
        alignment: 'justify',
        text: draft.h5,
        style: 'header'
    }, {
        style: 'paragraph',
        text: draft.p5
    }, {
        style: 'sign',
        text: sign
    }
];